export default {
  nav: {
    main: 'Principal',
    ordersAndInvoices: 'Pedidos y Facturas',
    drafts: 'Borradores',
    automation: 'Automatizacion',
    workspace: 'Espacio de trabajo',
    templates: 'Plantillas',
    delivery: 'Entrega',
    settings: 'Configuracion',
    shippingLabels: 'Etiquetas de envio',
    subscriptions: 'Suscripciones',
    support: 'Soporte',
    developer: 'Desarrollador',
    writeReview: 'Escribir una resena',
    supportTicket: 'Ticket de soporte',
    welcomeTour: 'Tour de bienvenida',
    administratorConsole: 'Consola de administrador',
    logout: 'Cerrar sesion',
  },
  dashboard: {
    pageTitle: 'Pedidos y Facturas',
    pageDescription: 'Manage your orders and invoices',
    title: 'Pedidos y Facturas',
    selectedOrders: '{count} pedidos seleccionados',
    completed: '% completado',
    processing: 'Procesando, por favor espere...',
    bulkDownload: 'Descarga masiva',
    upgradeBulkDownload: 'Mejore su plan para la descarga masiva',
    showFilters: 'Mostrar filtros',
    hideFilters: 'Ocultar filtros',
    creatingInvoices: 'Creando facturas, por favor espere...',
    bulkCreateInvoices: 'Crear facturas en lote',
    cannotCreateAutopilot: 'No puede crear facturas manualmente cuando el modo de facturacion esta en piloto automatico.',
    exportInvoices: 'Exportar facturas o pedidos',
    capturePayments: 'Capturar pagos manualmente',
    filterOrders: 'Filtrar pedidos',
    error: 'Algo salio mal...',
    close: 'Cerrar',
    chooseDate: 'Elegir una fecha',
    chooseIssueDate: 'Elegir una fecha de emision para las facturas seleccionadas',
    cancel: 'Cancelar',
    createInvoices: 'Crear facturas',
    storno: 'Storno',
    bulkOrderCapture: 'Captura masiva de pedidos',
  },
  search: {
    createdBetween: 'Creado entre',
    modifiedBetween: 'Modificado entre',
    orderNumber: 'Pedido #',
    invoiceNumber: 'Factura #',
    refundNumber: 'Reembolso #',
    customer: 'Cliente',
    payment: 'Pago',
    any: 'Cualquiera',
    authorized: 'Autorizado',
    pending: 'Pendiente',
    paid: 'Pagado',
    partiallyPaid: 'Parcialmente pagado',
    refunded: 'Reembolsado',
    voided: 'Anulado',
    partiallyRefunded: 'Parcialmente reembolsado',
    unpaid: 'Sin pagar',
    fulfillment: 'Cumplimiento',
    fulfilled: 'Enviado',
    partial: 'Parcial',
    unfulfilled: 'Sin enviar',
    loading: 'Cargando pedidos...',
    search: 'Buscar',
  },
  orderList: {
    noCustomer: 'Sin cliente',
    downloadOrder: 'Descargar pedido',
    deleteWarning: 'Importante! Esto eliminara todas las facturas y reembolsos creados despues de la fecha:',
    includingInvoice: 'incluyendo la factura seleccionada #',
    pressOk: 'Presione OK para continuar o Cancelar para abortar.',
    cannotCreateAutopilot: 'No puede crear facturas manualmente cuando el modo de facturacion esta en piloto automatico.',
    createInvoice: 'Crear factura para este pedido',
    create: 'Crear',
    addCreditNote: 'Agregar nota de credito',
    createStorno: 'Crear una factura de storno',
    refund: 'Reembolso',
    downloadInvoice: 'Descargar esta factura',
    download: 'Descargar',
    default: 'Predeterminado',
    downloadStorno: 'Descargar este storno/nota de credito',
    fulfillOrder: 'Completar pedido',
    orderNum: 'Pedido #',
    locPrefix: 'Prefijo de ubicacion',
    invoiceNum: 'Factura #',
    refundNum: 'Reembolso #',
    customerCol: 'Cliente',
    orderCreatedDate: 'Fecha de creacion del pedido',
    orderModifiedDate: 'Fecha de modificacion del pedido',
    delivered: 'Entregado',
    paymentStatus: 'Estado de pago',
    fulfillmentStatus: 'Estado de envío',
    totalOutstanding: 'Monto total pendiente',
    originalPrice: 'Precio original',
    noOrders: 'Su tienda no tiene pedidos para el estado seleccionado.',
    cannotCreateNoOrders: 'No puede crear facturas cuando no hay pedidos.',
    createOrdersFirst: 'Por favor cree al menos un pedido e intente de nuevo.',
    createOrders: 'Crear pedidos',
    loadingOrders: 'Cargando...',
    paidManual: 'Pagado - Manual',
    paid: 'Pagado',
    refunded: 'Reembolsado',
    pending: 'Pendiente',
    partiallyPaid: 'Parcialmente pagado',
    partiallyRefunded: 'Parcialmente reembolsado',
    fulfilled: 'Enviado',
    unfulfilled: 'Sin enviar',
    deliveryPending: 'Pendiente',
    deliverNow: 'Entregar ahora',
    deliveryPartial: 'Parcial',
    notDelivered: 'No entregado',
    deliverAgain: 'Entregar de nuevo',
    deliveryDetails: 'Detalles de entrega',
    deliveryFailed: 'Entrega fallida',
    sent: 'Enviado',
    failed: 'Fallido',
    toLabel: 'Para',
    folderLabel: 'Carpeta',
    open: 'Abierto',
    invoice: 'Factura',
    creditNote: 'Nota de crédito',
    stornoLabel: 'Storno',
    unknown: 'Desconocido',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet de clientes',
    shippyPro: 'ShippyPro',
    emailChannel: 'Correo electrónico',
    ftpChannel: 'FTP',
    revertToDate: 'Revertir a esta fecha',
    add: 'Agregar',
    close: 'Cerrar',
  },
  downloadDialog: {
    downloadType: 'Descargar {type}...',
    selectTemplate: 'Seleccione una plantilla de la galeria para exportar pedidos, facturas, facturas de storno o notas de credito.',
    getMoreTemplates: 'Obtener mas plantillas',
    createNewTemplate: 'Crear una nueva plantilla',
    allCreatedBetween: 'Todos los {type} creados entre',
    selectedType: '{type} seleccionados',
    and: 'y',
    status: 'Estado',
    any: 'Cualquiera',
    open: 'Abierto',
    closed: 'Cerrado',
    cancelled: 'Cancelado',
    paymentStatus: 'Estado de pago',
    fulfillmentStatus: 'Estado de envío',
    fulfilled: 'Enviado',
    partial: 'Parcial',
    unfulfilled: 'Sin enviar',
    authorized: 'Autorizado',
    pending: 'Pendiente',
    paid: 'Pagado',
    partiallyPaid: 'Parcialmente pagado',
    refunded: 'Reembolsado',
    voided: 'Anulado',
    partiallyRefunded: 'Parcialmente reembolsado',
    unpaid: 'Sin pagar',
    format: 'Formato',
    forLocation: 'Para ubicación',
    advancedOptions: 'Opciones avanzadas',
    exportHSCodes: 'Exportar códigos del sistema armonizado de inventario (más lento)',
    noteChrome: 'Nota: Para una descarga óptima se recomienda Chrome y desactivar cualquier bloqueador de anuncios.',
    downloadIndividually: 'Descargar individualmente',
    downloadGrouped: 'Descargar agrupado',
  },
  templates: {
    pageTitle: 'Plantillas',
    pageDescription: 'Customize your invoice templates',
    title: 'Plantillas',
    installTranslated: 'Instalar una plantilla traducida',
    installTranslatedDesc: 'Elija un idioma diferente haciendo clic en este boton.',
    createNew: 'Crear una nueva plantilla si es necesario',
    createNewDesc: 'Haga clic en este boton para crear una nueva plantilla si la necesita.',
    customize: 'Personalizar plantillas',
    customizeDesc: 'Haga clic en la plantilla predeterminada para personalizarla. Puede cambiar el logotipo, los colores y, para usuarios mas avanzados, el codigo detras.',
    defaultTemplate: 'Factura, Storno y Nota de credito (Predeterminado)',
    logo: 'Logotipo',
    colorPalette: 'Paleta de colores',
    getColorPalettes: 'Obtener paletas de colores',
    paperSize: 'Tamano de papel',
    format: 'Formato',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientacion',
    landscape: 'Horizontal',
    portrait: 'Vertical',
    margin: 'Margen (cm)',
    unsavedChanges: 'Cambios sin guardar',
    discard: 'Descartar',
    save: 'Guardar',
  },
  labels: {
    pageTitle: 'Etiquetas de envio',
    pageDescription: 'Create and manage shipping labels',
    title: 'Etiquetas de envio',
    glsRequiresPro: 'Las etiquetas de envio GLS para EEU requieren el plan Profesional.',
    upgradeDesc: 'Mejore a Profesional para crear y gestionar etiquetas de envio.',
    upgradePlan: 'Mejore su plan',
    eeuGls: 'EEU GLS',
    enabled: 'Habilitado',
    country: 'Pais',
    hungary: 'Hungria',
    slovakia: 'Eslovaquia',
    czech: 'Republica Checa',
    romania: 'Rumania',
    slovenia: 'Eslovenia',
    croatia: 'Croacia',
    senderId: 'ID del remitente',
    username: 'Usuario',
    password: 'Contrasena',
    name: 'Nombre',
    city: 'Ciudad',
    address: 'Direccion',
    zipCode: 'Codigo postal',
    contactPerson: 'Persona de contacto',
    phone: 'Telefono',
    email: 'Correo electronico',
    glsServices: 'Servicios GLS',
    expressService: 'Servicio express',
    exchangeService: 'Servicio de intercambio',
    smsService: 'Servicio SMS',
    smsText: 'Texto SMS',
    preAdviceService: 'Servicio de preaviso',
    unsavedChanges: 'Cambios sin guardar',
    discard: 'Descartar',
    save: 'Guardar',
  },
  billing: {
    pageTitle: 'Facturacion',
    pageDescription: 'Manage your subscription and billing',
    title: 'Facturacion',
    subscriptionFor: 'Plan de suscripcion para la tienda',
    currentlySubscribed: 'Actualmente esta suscrito a',
    plan: 'plan',
    cancelSubscription: 'Cancelar suscripcion',
    upgradePlan: 'Mejore su plan',
    professional: 'Profesional',
    proPriceMonthly: '$29.99 / mes',
    upgrade: 'Mejorar',
    includesAllStarter: 'Incluye todas las funciones de Starter, ademas de:',
    proFeature1: 'Suite de cumplimiento global: Prefijos basados en ubicacion y numeracion secuencial personalizada',
    proFeature2: 'Localizacion inteligente: Correos traducidos automaticamente y archivos PDF adjuntos localizados',
    proFeature3: 'Ciclo completo de documentos B2B: Proformas, presupuestos B2B y notas de credito',
    proFeature4: 'Sincronizacion contable B2B: Precision de 3 decimales por unidad y visualizacion multidivisa',
    proFeature5: 'Copias de seguridad automaticas: Copie facturas automaticamente a un servidor FTP seguro o Google Drive',
    proFeature6: 'Shopify Flow: Automatice la generacion, entrega y storno de facturas mediante triggers y acciones de Flow',
    proFeature7: 'Logica avanzada de IA: Use la IA en el dispositivo para clausulas condicionales complejas de diseno',
    proFeature8: 'Exportaciones UBL XML y ZUGFeRD / Factur-X (cumplimiento de facturacion electronica europea)',
    proFeature9: 'Codigos EPC QR para pagos instantaneos moviles en punto de venta',
    proFeature10: 'Etiquetas de envio GLS para EEU',
    proFeature11: 'Retencion fiscal de cumplimiento por 7 anos',
    currentlyUsing: 'Actualmente esta usando nuestro',
    free: 'gratuito',
    subscriptionPlan: 'plan de suscripcion.',
    monthlyUsage: 'Uso mensual',
    monthlyGenerated: '{count} / 50 facturas este mes',
    monthlyLimitReached: 'Limite mensual alcanzado. Mejore a Starter para facturas ilimitadas.',
    freePlan: 'Plan gratuito',
    freeToInstall: 'Gratis para instalar',
    freeFeature1: 'Hasta 50 facturas/pedidos por mes',
    freeFeature2: 'Acceso a las 31+ plantillas predefinidas',
    freeFeature3: 'Copiloto de IA basico',
    freeFeature4: 'Descargas e impresion de PDF estandar',
    freeFeature5: 'Suite de documentos estandar (Facturas, albaranes, recibos)',
    freeFeature6: 'Retencion segura de facturas por 3 meses',
    starterPlan: 'Plan Starter',
    starterPrice: '$9.99 / mes',
    starterPricePerInvoice: '+ 3 centavos por factura creada',
    subscribe: 'Suscribirse',
    starterFeature1: 'Facturas y pedidos ilimitados',
    starterFeature2: 'Entrega automatizada de PDF por correo electronico',
    starterFeature3: 'Acceso completo al editor hibrido y Copiloto de IA',
    starterFeature4: 'Integracion con Shopify POS y codigos de barras',
    starterFeature5: 'Shopify Flow: Triggers y acciones para automatizacion de facturas',
    starterFeature6: 'Exportaciones UBL XML / PEPPOL y ZUGFeRD / Factur-X (cumplimiento de facturacion electronica)',
    starterFeature7: 'Retencion segura de facturas por 1 ano',
    proTaxOverrides: 'Anulaciones de impuestos personalizadas: IVA / GST por producto y tasas a nivel de SKU',
    unsavedChanges: 'Cambios sin guardar',
    discard: 'Descartar',
    save: 'Guardar',
  },
  autopilot: {
    pageTitle: 'Automatizacion',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizacion',
    autoCreate: 'Crear facturas automaticamente',
    disabled: 'Deshabilitado (Manual)',
    whenCreated: 'Cuando se crean los pedidos',
    whenFulfilled: 'Cuando se completan los pedidos',
    whenPaid: 'Cuando se pagan los pedidos',
    autoCreateDesc: 'Las facturas se crearan en la fecha en que los pedidos se crean, completan o pagan.',
    autoStorno: 'Storno automatico de facturas',
    whenCancelled: 'Cuando los pedidos se cancelan o reembolsan',
    autoStornoDesc: 'Las facturas de storno se crearan en la fecha en que los pedidos se anulan/cancelan o se crean reembolsos.',
    cannotAutoFree: 'La creacion automatica de facturas no se puede realizar con el plan gratuito.',
    upgradePlan: 'Mejore su plan',
    unsavedChanges: 'Cambios sin guardar',
    discard: 'Descartar',
    save: 'Guardar',
  },
  delivery: {
    pageTitle: 'Entrega',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Entrega',
    settings: 'Configuracion',
    useOrderNumbers: 'Usar numeros de pedido para archivos',
    sendIfCountry: 'Enviar si el pais de la direccion de facturacion es',
    countryCodesHint: 'Liste todos los codigos de pais separados por punto y coma.',
    sendForTags: 'Enviar para clientes que tengan una de las etiquetas listadas',
    tagsHint: 'Liste todas las etiquetas separadas por punto y coma.',
    emailDelivery: 'Entrega por correo electronico',
    sendAsPdf: 'Enviar facturas como archivos PDF adjuntos a los clientes',
    autoSend: 'Enviar automaticamente cuando se crea una factura',
    subject: 'Asunto',
    body: 'Cuerpo',
    xmlAttachments: 'Adjuntos XML',
    attachUbl: 'Adjuntar XML UBL/PEPPOL (E-Factura)',
    attachZugferd: 'Adjuntar XML ZUGFeRD / Factur-X',
    sendTestEmail: 'Enviar correo de prueba',
    sending: 'Enviando...',
    customSmtp: 'Servidor SMTP personalizado',
    customSmtpDesc: 'Use su propio servidor de correo en lugar del predeterminado',
    enableSmtp: 'Habilitar SMTP personalizado',
    smtpHost: 'Host SMTP',
    port: 'Puerto',
    useSsl: 'Usar SSL/TLS',
    username: 'Usuario',
    password: 'Contrasena',
    fromEmail: 'Correo del remitente',
    fromName: 'Nombre del remitente',
    shopifyLiquid: 'Plantilla Shopify Liquid',
    pasteInto: 'Pegue esto en su',
    orderConfirmation: 'plantilla de confirmacion de pedido',
    toAddLink: 'para agregar un enlace de descarga.',
    downloadInvoice: 'Descargue su factura',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Enviar solicitudes a ClientsTablet cuando se crean facturas',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Enviar facturas PDF como documentos de aduana a ShippyPro para paises fuera de la UE',
    ftpBackup: 'Copia de seguridad FTP / SFTP',
    ftpDesc: 'Copiar facturas automaticamente a su servidor',
    enableFtp: 'Habilitar copia de seguridad FTP automatica',
    host: 'Host',
    useSftp: 'Usar SFTP (seguro)',
    destinationFolder: 'Carpeta de destino',
    xmlFiles: 'Archivos XML',
    includeUbl: 'Incluir XML UBL/PEPPOL (E-Factura)',
    includeZugferd: 'Incluir XML ZUGFeRD / Factur-X',
    testConnection: 'Probar conexion',
    testing: 'Probando...',
    pro: 'PRO',
    upgradeFtp: 'Mejore a Profesional para copiar facturas automaticamente a su servidor FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Sincronizar facturas automaticamente con su Drive',
    connected: 'Conectado',
    disconnect: 'Desconectar',
    notWorking: 'No funciona? Vaya a',
    googlePermissions: 'Permisos de Google',
    removeThenReconnect: 'elimine Invoice Browse, luego reconecte.',
    connectGoogleDrive: 'Conectar Google Drive',
    upgradeGoogleDrive: 'Mejore a Profesional para sincronizar facturas automaticamente con Google Drive.',
    unsavedChanges: 'Cambios sin guardar',
    discard: 'Descartar',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Guardar',
  },
  bookkeeping: {
    pageTitle: 'Configuracion',
    pageDescription: 'Configure your invoice settings',
    title: 'Configuracion',
    owner: 'Propietario',
    email: 'Correo electrónico',
    phone: 'Telefono',
    keepDifferentNumbering: 'Mantener numeracion de facturas diferente para cada ubicacion de pedido',
    keepDifferentNumberingDisabled: 'Mantener numeracion de facturas diferente para cada ubicacion de pedido no es una opcion habilitada con su plan.',
    locationEmailDesc: 'Esto le permite enviar correos y facturas traducidas segun la ubicacion del pedido: ubicacion de inventario, direccion de envio o de facturacion',
    upgradePlan: 'Mejore su plan',
    matchingCriteria: 'Criterios de coincidencia',
    locationId: 'ID de ubicacion',
    shippingCountryCode: 'Codigo de pais de la direccion de envio',
    billingCountryCode: 'Codigo de pais de la direccion de facturacion',
    matchLocationDesc: 'Coincidir una ubicacion basandose en el ID de ubicacion del pedido, codigo de pais de envio o facturacion.',
    companyInfo: 'Informacion de la empresa',
    name: 'Nombre',
    website: 'Sitio web',
    registrationNumber: 'Numero de registro',
    taxId: 'ID fiscal',
    addressSection: 'Direccion',
    streetName: 'Nombre de la calle',
    streetNumber: 'Numero de la calle',
    zip: 'Codigo postal',
    city: 'Ciudad',
    region: 'Region',
    country: 'Pais',
    bankingInfo: 'Informacion bancaria',
    bankName: 'Nombre del banco',
    swift: 'Swift',
    currency: 'Moneda',
    iban: 'IBAN',
    invoicing: 'Facturacion',
    decimalPlaces: 'Lugares decimales',
    invoicesPrefix: 'Prefijo de facturas',
    currentInvoiceNumber: 'Numero de factura actual',
    creditNotesPrefix: 'Prefijo de notas de credito',
    currentCreditNoteNumber: 'Numero de nota de credito actual',
    lastInvoiceDate: 'Fecha de la ultima factura',
    noInvoicesYet: 'Aun no se han creado facturas.',
    confirmReverting: 'Confirmar reversion del sistema',
    allInvoicesAfter: 'Todas las facturas y sus stornos emitidos despues de',
    willBeRemoved: 'seran eliminados. Continuar con la reversion del sistema?',
    cancel: 'Cancelar',
    revert: 'Revertir',
    revertDesc: 'Revertir el sistema eliminara todas las facturas creadas despues de la fecha seleccionada.',
    revertToDate: 'Revertir a esta fecha',
    reverting: 'Revirtiendo el sistema, por favor espere...',
    useOrderNumbering: 'Usar numeracion de pedidos',
    showVat: 'Mostrar IVA en las facturas',
    overrideTaxes: 'Anular impuestos',
    pricesIncludeTax: 'Los precios incluyen impuestos',
    productsTaxRate: 'Tasa de impuesto de productos',
    shippingTaxRate: 'Tasa de impuesto de envio',
    skusSeparated: 'SKUs separados por punto y coma',
    skusTaxRate: 'Tasa de impuesto de SKUs',
    useOrderDates: 'Usar fechas de creacion de pedidos para facturas',
    convertCurrency: 'Convertir precios a la moneda en la que paga el cliente',
    unsavedChanges: 'Cambios sin guardar',
    discard: 'Descartar',
    save: 'Guardar',
  },
  drafts: {
    pageTitle: 'Borradores',
    pageDescription: 'Manage your draft orders',
    title: 'Borradores',
    download: 'Descargar',
    newDraft: 'Nuevo borrador',
    exporting: 'Exportando {status}%...',
    accessNotGranted: 'Acceso a borradores de pedidos no concedido. Por favor',
    reLogin: 'vuelva a iniciar sesion',
    toGrantPermissions: 'para conceder los permisos requeridos de "Borradores de pedidos".',
    pushFailed: 'Error al enviar a Shopify:',
    exportError: 'Error de exportacion:',
    confirmDelete: 'Esta seguro de que desea eliminar este borrador?',
    incompleteCustomer: 'Los datos del cliente estan incompletos:',
    pushWithoutCustomer: 'El borrador se enviara a Shopify sin datos del cliente. Continuar?',
    customerNotInShopify: 'Este cliente aun no existe en Shopify.',
    warnings: 'Advertencias:',
    createCustomerAndPush: 'Crear el cliente en Shopify y enviar el borrador de pedido?',
    downloadTitle: 'Descargar borradores',
    cancel: 'Cancelar',
  },
  draftEdit: {
    number: "Número",
    prefix: "Prefijo",

    newDraft: 'Nuevo borrador',
    editDraft: 'Editar borrador',
    viewInShopify: 'Ver en Shopify',
    back: 'Volver',
    createDraft: 'Crear borrador',
    saveChanges: 'Guardar cambios',
    documentType: 'Tipo de documento',
    draftOrder: 'Borrador de pedido',
    quote: 'Presupuesto',
    proforma: 'Proforma',
    manualInvoice: 'Factura manual',
    currency: 'Moneda',
    expiryDate: 'Fecha de vencimiento',
    status: 'Estado',
    draft: 'Borrador',
    sent: 'Enviado',
    accepted: 'Aceptado',
    customer: 'Cliente',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electronico',
    phone: 'Telefono',
    company: 'Empresa',
    taxId: 'ID fiscal',
    billingAddress: 'Direccion de facturacion',
    address: 'Direccion',
    aptSuite: 'Apto/Suite',
    city: 'Ciudad',
    province: 'Provincia',
    countryField: 'Pais',
    zip: 'Codigo postal',
    shippingAddress: 'Direccion de envio',
    sameAsBilling: 'Igual que facturacion',
    lineItems: 'Articulos',
    shipping: 'Envio',
    shippingTitle: 'Titulo',
    shippingPlaceholder: 'ej. Envio estandar',
    price: 'Precio',
    note: 'Nota',
    notePlaceholder: 'Nota interna o mensaje para el cliente...',
    summary: 'Resumen',
    subtotal: 'Subtotal',
    discounts: 'Descuentos',
    tax: 'Impuesto',
    total: 'Total',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Ingrese la direccion de su tienda',
    loginWith: 'Iniciar sesion con',
    createAccount: 'Crear una nueva cuenta',
    placeholder: 'nombre-de-su-tienda',
    shopRequired: 'El nombre de la tienda es obligatorio',
    login: 'Iniciar sesion',
    shopify: 'Shopify',
    terms: 'Terminos y condiciones',
    privacy: 'Politica de privacidad',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Le gusta Invoice Browse?',
    description: 'Ha creado sus primeras facturas! Si la aplicacion le resulta util, una resena rapida en la Shopify App Store nos ayuda mucho.',
    reward: 'Como agradecimiento, restableceremos su contador de uso mensual a 0',
    leaveReview: 'Dejar una resena',
    maybeLater: 'Quizas mas tarde',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Bienvenido a Invoice Browse',
    welcomeContent: 'Permita que le muestre como puede usarlo.',
    dashboardTitle: 'Panel principal',
    dashboardContent: 'La pantalla que esta viendo es el panel principal. Aqui puede encontrar todos los pedidos y exportarlos a diferentes tipos de documentos como: facturas, albaranes y otros.',
    automationTitle: 'Facilite su vida',
    automationContent: 'Habilite la automatizacion para crear facturas cada vez que los pedidos se pagan o reembolsan.',
    templatesTitle: 'Personalizar plantillas',
    templatesContent: 'Entre aqui para traducir su plantilla, personalizarla o crear una nueva.',
    deliveryTitle: 'Entrega',
    deliveryContent: 'Configure nuestra aplicacion para copiar automaticamente los documentos creados a FTP, Google Drive, o como adjuntos en correos electronicos.',
    settingsTitle: 'Configuracion',
    settingsContent1: 'Ajuste el telefono de la empresa, correo electronico y otros campos usados en los documentos.',
    settingsContent2: 'Cambie el numero inicial del documento o borre documentos creados despues de una fecha.',
    settingsContent3: 'Anule las tasas de IVA para envio y productos',
    settingsContent4: 'Cambie los lugares decimales para los numeros',
    reviewTitle: 'Escribir una resena',
    reviewContent: 'Apoye a nuestro equipo escribiendonos una buena resena!',
    tourTitle: 'Tour de bienvenida',
    tourContent: 'Puede abrir este tour de nuevo desde aqui.',
    createDocTitle: 'Cree su primer documento',
    createDocContent: 'Haga clic en el boton Crear para crear su primer documento.',
    docNumberTitle: 'Numero de documento',
    docNumberContent: 'El primer documento tiene asignado el numero 1. Si desea comenzar con otro numero, puede cambiarlo desde Configuracion.',
    downloadDocTitle: 'Descargar documento',
    downloadDocContent: 'Haga clic en el menu desplegable Descargar y seleccione una plantilla de documento para exportar su pedido como PDF.',
  },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    discard: 'Descartar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    loading: 'Cargando...',
    unsavedChanges: 'Cambios sin guardar',
    upgradePlan: 'Mejore su plan',
  },
  languageSelector: {
    label: 'Idioma',
    auto: 'Detectar automaticamente',
  },
  draftList: {
    draftNum: 'Borrador #',
    shopifyId: 'Shopify ID',
    type: 'Tipo',
    customer: 'Cliente',
    total: 'Total',
    status: 'Estado',
    delivered: 'Entregado',
    date: 'Fecha',
    actions: 'Acciones',
    noCustomer: 'Sin cliente',
    noDrafts: 'No se encontraron borradores ni presupuestos.',
    loading: 'Cargando...',
    download: 'Descargar',
    default: 'Predeterminado',
    pending: 'Pendiente',
    deliverNow: 'Entregar ahora',
    deliveryDetails: 'Detalles de entrega',
    sent: 'Enviado',
    failed: 'Fallido',
    deliverAgain: 'Entregar de nuevo',
    partial: 'Parcial',
    notDelivered: 'No entregado',
    deliveryFailed: 'Entrega fallida',
    unknown: 'Desconocido',
    edit: 'Editar',
    send: 'Enviar',
    pushToShopify: 'Enviar a Shopify',
    complete: 'Completar',
    duplicate: 'Duplicar',
    delete: 'Eliminar',
    quote: 'Presupuesto',
    proforma: 'Proforma',
    draftOrder: 'Pedido borrador',
    manualInvoice: 'Factura manual',
  },
  draftSearch: {
    createdBtw: 'Creado entre',
    draftNum: 'Borrador #',
    shopifyId: 'Shopify ID',
    customer: 'Cliente',
    status: 'Estado',
    type: 'Tipo',
    delivery: 'Entrega',
    any: 'Todos',
    draft: 'Borrador',
    sent: 'Enviado',
    accepted: 'Aceptado',
    expired: 'Expirado',
    converted: 'Convertido',
    cancelled: 'Cancelado',
    quote: 'Presupuesto',
    proforma: 'Proforma',
    draftOrder: 'Pedido borrador',
    manualInvoice: 'Factura manual',
    delivered: 'Entregado',
    notDelivered: 'No entregado',
    pending: 'Pendiente',
    search: 'Buscar',
  },
  draftDownload: {
    title: 'Descargar borradores y presupuestos...',
    selectTemplate: 'Seleccione una plantilla de la galería para exportar borradores, presupuestos o proformas.',
    allDraftsBetween: 'Todos los borradores entre',
    selectedDrafts: 'Borradores seleccionados',
    and: 'y',
    status: 'Estado',
    documentType: 'Tipo de documento',
    any: 'Todos',
    draft: 'Borrador',
    sent: 'Enviado',
    accepted: 'Aceptado',
    expired: 'Expirado',
    converted: 'Convertido',
    cancelled: 'Cancelado',
    quote: 'Presupuesto',
    proforma: 'Proforma',
    draftOrder: 'Pedido borrador',
    manualInvoice: 'Factura manual',
    format: 'Formato',
    noTemplates: 'No se encontraron plantillas',
    noTemplatesForType: 'No se encontraron plantillas para el tipo de documento "{type}".',
    installTemplates: 'Instalar plantillas',
    toStartExporting: 'para comenzar a exportar.',
    noteChrome: 'Nota: Para una descarga óptima se recomienda Chrome y desactivar cualquier bloqueador de anuncios.',
    cancel: 'Cancelar',
    downloadIndividually: 'Descargar individualmente',
    downloadGrouped: 'Descargar agrupado',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instalar nueva plantilla',
    tabStyle: 'Estilo',
    tabContent: 'Contenido',
    tabTranslations: 'Traducciones',
    tabSettings: 'Configuración',
    tabCode: 'Código',
    tabCopilot: 'Copiloto IA',
    logo: 'Logo',
    colorPalette: 'Paleta de colores',
    colorText: 'Texto',
    colorBg: 'Fondo',
    colorBorder: 'Borde',
    colorPrimary: 'Primario',
    colorAccent: 'Acento',
    font: 'Fuente',
    fontDefault: 'Predeterminada (DM Sans)',
    fontSize: 'Tamaño de fuente',
    fontSizeDefault: 'Predeterminado (11.5px)',
    fontSizeCompact: 'Compacto',
    fontSizeSmall: 'Pequeño',
    fontSizeMediumSmall: 'Medio-pequeño',
    fontSizeMedium: 'Medio',
    fontSizeMediumLarge: 'Medio-grande',
    fontSizeLarge: 'Grande',
    fontSizeExtraLarge: 'Extra grande',
    documentTitle: 'Título del documento',
    documentTitlePlaceholder: 'ej. Factura, Factura fiscal...',
    noToggleSupport: 'Esta plantilla no admite controles de alternancia. Cambie a una plantilla de galería para personalización completa.',
    sections: 'Secciones',
    shippingAddress: 'Dirección de envío',
    bankPaymentDetails: 'Datos bancarios/de pago',
    paymentStatusBadge: 'Insignia de estado de pago',
    orderNotes: 'Notas del pedido',
    trackingFulfillment: 'Seguimiento/cumplimiento',
    termsConditions: 'Términos y condiciones',
    signatureLines: 'Líneas de firma',
    qrCode: 'Código QR',
    lineItems: 'Artículos',
    taxColumns: 'Columnas de impuestos (IVA)',
    productSku: 'SKU del producto',
    productImages: 'Imágenes del producto',
    discountBreakdown: 'Desglose de descuentos',
    itemWeight: 'Peso del artículo',
    hsCode: 'Código HS (aduanas)',
    mergeDiscounts: 'Integrar descuentos en el precio del producto',
    showOrderDiscountAsSummary: 'Mostrar el descuento del pedido como línea de resumen',
    totals: 'Totales',
    subtotalBeforeTax: 'Subtotal (antes de impuestos)',
    taxBreakdownByRate: 'Desglose de impuestos por tasa',
    shippingCostSeparate: 'Costo de envío como línea separada',
    dueDate: 'Fecha de vencimiento',
    formatting: 'Formato',
    dateFormat: 'Formato de fecha',
    decimalPlaces: 'Decimales',
    paymentTerms: 'Condiciones de pago',
    paymentTermsNone: 'Ninguna',
    thankYouMessage: 'Mensaje de agradecimiento',
    thankYouPlaceholder: '¡Gracias por su compra!',
    countryMatchTitle: 'Usar esta plantilla cuando la dirección de envío o facturación coincida con este país',
    addressType: 'Tipo de dirección',
    addressDisabled: 'Desactivado',
    addressShipping: 'Dirección de envío',
    addressBilling: 'Dirección de facturación',
    country: 'País',
    anyCountry: 'Cualquier país',
    countryMatchDesc: 'Cuando está habilitado, esta plantilla se usará automáticamente para pedidos donde la dirección seleccionada coincida con el país elegido.',
    languagePreset: 'Idioma predefinido',
    selectLanguage: 'Seleccionar idioma...',
    languagePresetDesc: 'Seleccionar un idioma completa todas las etiquetas a continuación. Luego puede personalizar campos individuales.',
    paperSize: 'Tamaño de papel',
    format: 'Formato',
    orientation: 'Orientación',
    portrait: 'Vertical',
    landscape: 'Horizontal',
    margin: 'Margen (cm)',
    template: 'Plantilla',
    templateName: 'Nombre',
    systemAlias: 'Alias del sistema',
    systemAliasDesc: 'para rutas URL POS/Admin',
    systemAliasNone: 'Ninguno',
    defaultTemplate: 'Plantilla predeterminada',
    defaultTemplateDesc: 'Usada para enlaces directos compartidos con clientes.',
    posRouteDesc: 'Se asigna a /template/[alias]/receipt.pdf para integración POS.',
    documentType: 'Tipo de documento',
    invoiceCreditNote: 'Factura + Nota de crédito',
    order: 'Pedido',
    invoiceOnly: 'Solo factura',
    quoteEstimate: 'Presupuesto/Estimación',
    proformaInvoice: 'Factura proforma',
    refund: 'Reembolso',
    stornoInvoice: 'Factura de anulación',
    creditNoteOnly: 'Solo nota de crédito',
    reportLiquid: 'Informe (solo Liquid)',
    hideRemovedItems: 'Ocultar artículos eliminados/reembolsados',
    location: 'Ubicación',
    locationEmpty: 'Dejar vacío para usar en todas las ubicaciones',
    dangerZone: 'Zona de peligro',
    dangerZoneDesc: 'Eliminar permanentemente esta plantilla de su cuenta.',
    removeTemplate: 'Eliminar plantilla',
    bodyTemplate: 'Plantilla principal',
    bodyTemplateDesc: 'Usa sintaxis Mustache o Liquid. Haga clic en un fragmento:',
    rowTemplate: 'Plantilla de fila',
    rowTemplateDesc: 'Se renderiza una vez por artículo. Haga clic en un fragmento:',
    variableReference: 'Referencia de variables',
    formatCode: 'Formatear código',
    insert: 'Insertar',
    copy: 'Copiar',
    loadModelContinue: 'Cargar modelo y continuar',
    cancel: 'Cancelar',
    copilotPlaceholder: 'Pruebe: traducir al español, mostrar columnas de impuestos, añadir código de barras...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Deshacer',
    redo: 'Rehacer',
    aiThinking: 'La IA está pensando...',
    proposedChanges: 'Cambios propuestos',
    applyChanges: 'Aplicar cambios',
    dismiss: 'Descartar',
    aiEngineReady: 'Motor IA listo',
    loadingAiModel: 'Cargando modelo IA...',
    aiEngineOff: 'Motor IA apagado —',
    loadForAdvanced: 'cargar para edición avanzada',
    instantCommands: 'traducir, mostrar/ocultar secciones, añadir fragmentos, cambiar fuente/colores/papel',
    aiEngineDesc: 'ediciones HTML estructurales, cambios de diseño, modificaciones personalizadas',
    aiLocalDesc: 'El modelo se ejecuta localmente vía WebGPU — ningún dato sale de su navegador.',
    aiUpgradeDesc: 'actualice a Starter o Professional para desbloquear la edición IA avanzada.',
    upgrade: 'Actualizar',
    loadAiQuestion: '¿Cargar motor IA?',
    loadAiDesc: 'El modelo IA se descargará y ejecutará localmente vía WebGPU. Requiere ~1-3 GB de VRAM/RAM libre y una GPU moderna.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/es.js